import React from 'react'

//import { createStore, applyMiddleware } from 'redux'
//import { Provider } from 'react-redux'
//import thunkMiddleware from 'redux-thunk'
//import { createLogger } from 'redux-logger'
//import { composeWithDevTools } from 'redux-devtools-extension'

//import { bridgeProductManagementApp } from './GlobalStateContainer'
//import ProductManageReactApp from './ProductManageReactApp'

class MainHorizontalNav extends React.Component {
    constructor(props) {
        super(props);
    }

    subMenuIndex = 0;

    renderTopLevelMenuItem = (menuItem) => {
        if (menuItem.Children && menuItem.Children.length > 0) {
            const childrenMenuItems = menuItem.Children.map((child) => this.renderChildMenuItem(child));

            return (
                <li className="submenu1" key={menuItem.Title}>
                    <a href="#" data-toggle="collapse" data-target={"#submenu-" + (++this.subMenuIndex)} aria-expanded="false" className="dropdown-toggle collapsed">
                        {!!menuItem.FontAwesomeClass && <i className={"fa fa-" + menuItem.FontAwesomeClass}></i>}
                        <span className="main"> {menuItem.Title}<span className="arrow"><i className="fa fa-angle-left"></i></span></span>
                    </a>
                    <ul className="nav list-unstyled collapse" id={"submenu-" + this.subMenuIndex}>
                        <li className="submenu-title hidden">
                            <span>{menuItem.Title}</span>
                        </li>
                        {childrenMenuItems}
                    </ul>
                </li>
            );
        } else {
            return (
                <li key={menuItem.Title}>
                    <a href="#" target={menuItem.Target}>
                        {!!menuItem.FontAwesomeClass && <i className={"fa fa-" + menuItem.FontAwesomeClass}></i>}
                        <span className="main"> {menuItem.Title}</span>
                    </a>
                </li>
            );
        }
    }   

    renderChildMenuItem = (childMenuItem) => {
        if (childMenuItem.Children && childMenuItem.Children.length > 0) {
            const grandchildrenMenuItems = childMenuItem.Children.map((grandchild) => this.renderGrandChildMenuItem(grandchild));
            return (
                <li className="submenu2" key={childMenuItem.Title}>
                    <a href="#" data-toggle="collapse" data-target={"#submenu-" + (++this.subMenuIndex)} aria-expanded="false" className="dropdown-toggle collapsed">
                        {childMenuItem.Title}
                        <span className="arrow"><i className="fa fa-angle-left"></i></span>
                    </a>
                    <ul className="nav list-unstyled collapse " id={"submenu-" + this.subMenuIndex}>
                        {grandchildrenMenuItems}
                    </ul>
                </li>
            );
        }
        else {
            return (
                <li key={childMenuItem.Title}>
                    <a href={childMenuItem.PageLinkUrl} target={childMenuItem.Target}>{childMenuItem.Title}</a>
                </li>
            );
        }
    }

    renderGrandChildMenuItem = (grandChildMenuItem) => {
        return (
            <li key={grandChildMenuItem.Title}>
                <a href={grandChildMenuItem.PageLinkUrl} target={grandChildMenuItem.Target}>
                    {grandChildMenuItem.Title}
                </a>
            </li>
        );
    }

    render() {
        this.subMenuIndex = 0;
        let menuStart;
        for (let i = 0; i < this.props.menuItems.length; i++) {
            if (this.props.menuItems[i].IsContainerPage) {
                menuStart = this.props.menuItems[i];
                break;
            }
        }
        if (!menuStart) {
            menuStart = this.props.menuItems;
        }

        const menuItems = menuStart.map((menuItem) => this.renderTopLevelMenuItem(menuItem));

        return (
            <nav id="sidebar" className="hidden-xs hidden-sm">
                <ul className="nav list-unstyled">
                    {menuItems}
                </ul>
                <div className="text-center hidden-xs hidden-sm">
                    <button type="button" className="sidebarCollapse btn btn-block">
                        <i className="fa fa-arrow-right"></i>
                    </button>
                </div>
            </nav>
        );
    }
}

export default MainHorizontalNav
